import { Currencies } from '@orbital/games-frontend-library'
import React from 'react'

export const combinations = [
  '',
  'High Card',
  'Pair',
  'Two Pairs',
  'Three of a kind',
  'Straight',
  'Flush',
  'Full House',
  'Four of a kind',
  'Straight Flush',
  'Royal Flush',
]

const playerTextBetReply = (
  type: number,
  currency?: string,
  winAmount?: string,
  state?: number,
) => (
  <>
    {combinations[type]}
    {state === 5 && (
      <span>
        wins {Currencies[currency]}
        {winAmount && (+winAmount).toFixed(2)}
      </span>
    )}
  </>
)
const dealerTextBetReply = (type: number, state: number) => (
  <>
    {combinations[type]}
    {type !== 0 && state === 6 && <span>wins</span>}
  </>
)

export const texts = { dealerTextBetReply, playerTextBetReply }
